/**
 * @file Toast 组件
 * @author hardylin <hardylin@tencent.com>
 */
import Vue from 'vue'
import Toast from './toast.vue'

const ToastConstructor = Vue.extend(Toast)

// toast 实例栈
let toastStack = []

function getAnInstance() {
    if (toastStack.length > 0) {
        return toastStack.pop()
    }
    return new ToastConstructor().$mount()
}

/**
 * Toast 提示
 * @param {String} content - 提示内容
 */
export default function ToastInstance(content) {
    let instance = getAnInstance()
    clearTimeout(instance.timer)
    instance.content = content.toString()
    instance.show = true
    document.body.appendChild(instance.$el)
    instance.timer = setTimeout(() => {
        instance.show = false
        toastStack.push(instance)
    }, 3000)
}